<div class="header">
  <span class="title">Ответ</span>
  <span class="buttons" *ngIf="!readonly && !editMode">
      <button mat-icon-button
              matTooltip="Редактировать"
              (click)="onEdit($event)">
        <mat-icon>edit</mat-icon>
      </button>
    </span>
</div>
<div class="body">
  <div class="text" *ngIf="!editMode && answer.text">{{answer.text}}</div>
  <div class="no-text" *ngIf="!editMode && !answer.text">Не заполнен</div>
  <form class="editor" *ngIf="editMode"
        [formGroup]="form" (ngSubmit)="onSubmit($event)">
    <mat-form-field>
      <mat-label>Ответ</mat-label>
      <textarea #input matInput formControlName="text"
                placeholder="Введите ответ"
                [autofocus]="['autofocus']"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="5"
                rows="2"></textarea>
    </mat-form-field>
    <div class="buttons">
      <button mat-icon-button
              matTooltip="Сохранить"
              type="submit"
              (click)="onSubmit($event)">
        <mat-icon>done</mat-icon>
      </button>
      <button mat-icon-button
              matTooltip="Отмена"
              type="button"
              (click)="onCancel($event)">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </form>
</div>
